<template>
    <v-card>
        <v-card-title primary-title>
            <div>
                <h3 class="headline mb-0">General</h3>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="show = !show">
                <v-icon>{{ show ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text v-show="show">
            <v-layout wrap>
                <v-flex xs12 sm5>
                    <v-text-field
                    label="Name"
                    v-model="system.name"
                    @input="changed"
                    ></v-text-field>
                </v-flex>
                <v-flex sm1></v-flex>
                <v-flex xs12 sm5>
                    <v-textarea
                    label="Description"
                    v-model="system.description"
                    @input="changed"
                    ></v-textarea>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions v-show="show">
            <v-btn text color="orange" :disabled="!applyEnabled" @click="reset">Reset</v-btn>
            <v-btn text color="orange" :disabled="!applyEnabled" @click="apply">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    data() {
      return {
        show: this.display,
        init: false,
        applyEnabled: false
      }
    },
    props: {
        system: Object,
        display: Boolean
    },
    methods: {
        async reset() {
            await this.$store.dispatch("systems/resetActiveSystemInfo")
            this.applyEnabled = false
        },
        async apply() {

            try {
                await this.$store.dispatch("systems/saveActiveSystemInfo")
                this.applyEnabled = false
            } catch (e) {
                console.error(e)
            }
        },
        changed() {
            this.applyEnabled = !!this.system.id
        }
    },
    updated() {
        if (!this.init) {
            this.init = true
            this.show = !this.system.id
        }
    }
}
</script>
